/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MealSchedule from './meal-schedule';
import MealScheduleDetail from './meal-schedule-detail';
import MealScheduleUpdate from './meal-schedule-update';
import MealScheduleDeleteDialog from './meal-schedule-delete-dialog';

const MealScheduleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MealSchedule />} />
    <Route path="new" element={<MealScheduleUpdate />} />
    <Route path=":id">
      <Route index element={<MealScheduleDetail />} />
      <Route path="edit" element={<MealScheduleUpdate />} />
      <Route path="delete" element={<MealScheduleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MealScheduleRoutes;
